export default [
  { key: 'protein', label: 'Protein', unit: 'g' },
  { key: 'totalFat', label: 'Fat', unit: 'g' },
  { key: 'fiber', label: 'Fiber', unit: 'g' },
  { key: 'calories', label: 'Calories', unit: 'kcal' },
];
